import JNumberField from '@atoms/JNumberField';
import { TableCell, TableRow } from '@mui/material';

interface IProps {
  etablishmentName: string;
  repartition?: number;
  onChange: (_: number) => void;
  creditsAlertThreshold: number;
}

const RowRepartition = ({
  etablishmentName,
  repartition,
  onChange,
  creditsAlertThreshold,
}: IProps) => {
  return (
    <TableRow data-test={`threshold-list-row-${etablishmentName}`}>
      <TableCell>{etablishmentName}</TableCell>
      <TableCell>
        <JNumberField
          size="medium"
          name={`repartition-field-${etablishmentName}`}
          defaultValue={repartition}
          onNumberChange={(value) => {
            onChange(value);
          }}
          hideButtons={true}
          fullWidth
        ></JNumberField>
      </TableCell>
      <TableCell>
        <JNumberField
          size="medium"
          name={`threshold-field-${etablishmentName}`}
          defaultValue={creditsAlertThreshold}
          onNumberChange={(value) => {
            console.log(value);
          }}
          hideButtons={true}
          fullWidth
          disabled
        ></JNumberField>
      </TableCell>
    </TableRow>
  );
};

export default RowRepartition;
